import React from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ClientProvider } from "@/contexts/ClientContext";
import { SessionManager } from "@/components/Auth/SessionManager";

import Index from "./pages/Index";
import Auth from "./pages/Auth";
import AdminLogin from "./pages/AdminLogin";
import UserPortal from "./pages/UserPortal";
import AdminConsole from "./pages/AdminConsole";
import NotFound from "./pages/NotFound";
import PublicFormulario from "./pages/PublicFormulario";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import UserOnlyRoute from "./components/Auth/UserOnlyRoute";
import SetPassword from "./pages/SetPassword";
import ForgotPassword from "./pages/ForgotPassword";
import AuthCallback from "./pages/AuthCallback";
import PaymentSuccess from "./pages/PaymentSuccess";

// Novas páginas de onboarding seguro
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import PersonalData from "./pages/onboarding/PersonalData";
import CompanyData from "./pages/onboarding/CompanyData";
import PlanSelection from "./pages/onboarding/PlanSelection";
import LicenseExpired from "./pages/LicenseExpired";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      staleTime: Infinity, // Dados nunca ficam stale automaticamente
      gcTime: 30 * 60 * 1000, // Garbage collection após 30 minutos
      retry: 1,
      retryOnMount: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <ClientProvider>
        <Toaster />
        <Sonner />
        <SessionManager />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Auth />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/f/:token" element={<PublicFormulario />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            
            {/* Novo fluxo de onboarding seguro */}
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/onboarding/personal" element={<PersonalData />} />
            <Route path="/onboarding/company" element={<CompanyData />} />
            <Route path="/onboarding/plan" element={<PlanSelection />} />
            <Route path="/license-expired" element={<LicenseExpired />} />
            
            <Route path="/portal" element={
              <UserOnlyRoute>
                <UserPortal />
              </UserOnlyRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminConsole />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Index />
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </ClientProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
